/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react'

import { const_var } from '../../../redux/reducers/reducer';
import { GlassTextureImg } from '../../../utils/Textures';

import DoorModel from './DoorModel';
import WindowModel from './WindowModel';
import { wallnameBySec, wallNameByStorageSec } from '../../../redux/reducers/building_component/componentReducer';

const DoorWindows = ({ section='center' }) => {
    const [isMapLoad, setIsMapLoad] = useState(false);

    const glassTexture = useMemo(() => {
        let texture = null;

        if (isMapLoad === false) {
            texture = new THREE.CubeTextureLoader().load([ process.env.REACT_APP_BASE_URL+GlassTextureImg, 
                                                           process.env.REACT_APP_BASE_URL+GlassTextureImg, 
                                                           process.env.REACT_APP_BASE_URL+GlassTextureImg, 
                                                           process.env.REACT_APP_BASE_URL+GlassTextureImg, 
                                                           process.env.REACT_APP_BASE_URL+GlassTextureImg, 
                                                           process.env.REACT_APP_BASE_URL+GlassTextureImg])

            setIsMapLoad(true);
        }

        return texture;
    }, []);

    const doorParams = {
        id: 0,
        compName: "temp-door",
        width: 5,
        height: 6,

        trimWidth: 0.1,
        doorColor: '#ffffff',
        overlapTrimColor: "#ff0000",
        glassTexture: glassTexture,
    }
    
    return (
        <>
            {const_var.newDoorsArray?.length > 0 && const_var.newDoorsArray.map(item =>
                (
                    section.includes('storage')
                    ?
                    wallNameByStorageSec[item.userData.wallName] === section
                    :
                    (wallnameBySec[item.userData.wallName] === section && (!wallNameByStorageSec[item.userData.wallName]?.includes('storage') || item.userData.wallName === "c_b_l_s_r_w" || item.userData.wallName === "c_b_l_s_f_w" || item.userData.wallName === "c_b_l_s_b_w" || item.userData.wallName === "c_b_r_s_l_w" || item.userData.wallName === "c_b_r_s_f_w" || item.userData.wallName === "c_b_r_s_b_w"))
                ) && (
                <group key={item.uniqueId} name={`door_model_on_${item.userData.wallName}`}>
                    {(item.userData.compType === "garage_door" || item.userData.compType === "garage_door_frameout" || item.userData.compType === "walkin" || item.userData.compType === "walkin_frameout") && (
                        <DoorModel
                            id={item.uniqueId}
                            wallName={item.userData.wallName}
                            compName={item.userData.compName}
                            compType={item.userData.compType}
                            width={item.width}
                            height={item.height}
                            defaultPositionX={item.positionX}
                            defaultPositionY={item.positionY}
                            trimWidth={doorParams.trimWidth}
                            doorColor={(item!=undefined && item.doorColor!=undefined)?item.doorColor:doorParams.doorColor}
                            overlapTrimColor={doorParams.overlapTrimColor}
                            glassTexture={doorParams.glassTexture}
                        />
                    )}
                    {(item.userData.compType === "window" || item.userData.compType === "window_frameout") && (
                        <WindowModel
                            id={item.uniqueId}
                            wallName={item.userData.wallName}
                            compName={item.userData.compName}
                            compType={item.userData.compType}
                            width={item.width}
                            height={item.height}
                            defaultPositionX={item.positionX}
                            defaultPositionY={item.positionY}
                            trimWidth={doorParams.trimWidth}
                            doorColor={doorParams.doorColor}
                            overlapTrimColor={doorParams.overlapTrimColor}
                            glassTexture={doorParams.glassTexture}
                        />
                    )}
                </group>
            ))}
        </>
    )
}

export default DoorWindows